import { StdResponse, request } from "@/global/config/request";
import { GlobalLoadDisplacement } from "@/global/interface/lib-device/global-load-dispalcement";


export function getGlobalLoadDisplacementDetail(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-load-displacements/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalLoadDisplacement(data: GlobalLoadDisplacement, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-load-displacements`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalLoadDisplacement(uuid: string, data: GlobalLoadDisplacement, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-load-displacements/${uuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalLoadDisplacement(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/global-load-displacements/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function getGlobalLoadDisplacements(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-load-displacements`, {
        params: {
            ...params,
        }
    })
}

export function downloadLoadDisplacementImportTemplate(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-load-displacements/import-template`, {
        params: params,
        responseType: 'blob',
    })
}

export function uploadLoadDisplacementTemplate(uuid: string, file: FormData, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-load-displacements/${uuid}/upload-template`, file, {
        params: params,
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}